/**
 * @generated SignedSource<<e0294b08a0f0ff17cf40515be6a20fd8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoButton_linkData$data = {
  readonly isLinkable: boolean | null;
  readonly path: string | null;
  readonly " $fragmentType": "SeoButton_linkData";
};
export type SeoButton_linkData$key = {
  readonly " $data"?: SeoButton_linkData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoButton_linkData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoButton_linkData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};

(node as any).hash = "7d1278475590512cc0a564e9186a15f1";

export default node;
